/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Measures_Sheet_TitleInputs */

const en_us2_body_measures_sheet_title = /** @type {(inputs: Body_Measures_Sheet_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New measurement`)
};

const pt_br2_body_measures_sheet_title = /** @type {(inputs: Body_Measures_Sheet_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nova medida`)
};

const es_419_body_measures_sheet_title = /** @type {(inputs: Body_Measures_Sheet_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nueva medida`)
};

const pt_pt2_body_measures_sheet_title = /** @type {(inputs: Body_Measures_Sheet_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nova medida`)
};

const fr_fr2_body_measures_sheet_title = /** @type {(inputs: Body_Measures_Sheet_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nouvelle mesure`)
};

const de_de2_body_measures_sheet_title = /** @type {(inputs: Body_Measures_Sheet_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neue Messung`)
};

const it_it2_body_measures_sheet_title = /** @type {(inputs: Body_Measures_Sheet_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuova misura`)
};

/**
* | output |
* | --- |
* | "New measurement" |
*
* @param {Body_Measures_Sheet_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_measures_sheet_title = /** @type {((inputs?: Body_Measures_Sheet_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Measures_Sheet_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_measures_sheet_title(inputs)
	if (locale === "es-419") return es_419_body_measures_sheet_title(inputs)
	if (locale === "pt-PT") return pt_pt2_body_measures_sheet_title(inputs)
	if (locale === "fr-FR") return fr_fr2_body_measures_sheet_title(inputs)
	if (locale === "de-DE") return de_de2_body_measures_sheet_title(inputs)
	if (locale === "it-IT") return it_it2_body_measures_sheet_title(inputs)
	return en_us2_body_measures_sheet_title(inputs)
});
export { body_measures_sheet_title as "body-measures.sheet_title" }